<template>
  <v-card>
    <div class="container-header">
      <h3 style="font-weight: 600; font-size: 18px;">
        Painel de Solicitações
      </h3>

      <div class="container-header-actions">
        <v-text-field
          v-model="searchInput"
          :prepend-inner-icon="icons.mdiMagnify"
          label="Pesquisar"
          outlined
          hide-details
          dense
          class=""
          @input="handleFilterData"
        >
        </v-text-field>

        <v-btn
          :color="filterButtonColor"
          outlined
          @click="showModalFilter = true"
        >
          <v-icon
            size="20"
          >
            {{ icons.mdiFilterVariant }}
          </v-icon>
          <span>
            FILTRO
          </span>
        </v-btn>

        <v-btn
          color="info"
          outlined
          @click="showRegisterNewSolicitationModal = true"
        >
          <v-icon
            size="20"
          >
            {{ icons.mdiPlaylistPlus }}
          </v-icon>
          <span>
            NOVA VIAGEM
          </span>
        </v-btn>

        <v-btn
          v-show="isFiltered"
          color="error"
          class="me-3"
          outlined
          @click="filterReset"
        >
          <v-icon
            size="20"
            class="me-1"
          >
            {{ icons.mdiClose }}
          </v-icon>
          <span>
            Limpar
          </span>
        </v-btn>
      </div>
    </div>
    <article
      class="d-flex"
      style="gap: 50px;"
    >
      <section>
        <div
          v-for="(tab, index) in tabs"
          :key="index"
        >
          <div
            class="d-flex py-2 align-center tab-item"
            :class="getTabClasses(index)"
            style="gap: 10px; width: auto;"
          >
            <v-icon
              class="ml-3"
              :class="getIconClasses(index)"
              style="cursor: pointer; transition: color 0.2s ease;"
              @click="setActiveTab(index)"
            >
              {{ tab.icon }}
            </v-icon>
            <span
              style="font-size: 16px; cursor: pointer; transition: color 0.2s ease;"
              :class="getTextClasses(index)"
              @click="setActiveTab(index)"
            >{{ tab.title }}</span>
            <div
              :style="{
                background: tab.badgeBackgroundColor,
              }"
              style="padding: 10px 10px; align-items: center; justify-content: center; border-radius: 30px; width: 35px;  cursor: pointer;"
              class="d-flex px-3 py-1"
              @click="setActiveTab(index)"
            >
              <span
                style="font-size: 12px; font-weight: 500;"
                :style="{ color: tab.badgeTextColor }"
              >{{ tab.solicitation_quantity }}</span>
            </div>
          </div>
        </div>
      </section>
      <!-- Aqui vai a seção de conteúdo -->
      <section
        class="d-flex flex-column py-5 scroll-area"
        style="gap: 16px;"
      >
        <div
          v-if="loading"
          class="d-flex flex-column"
          style="gap: 16px; width: 100%;"
        >
          <TransportSolicCardSkeleton
            v-for="i in 3"
            :key="i"
          />
        </div>
        <NoDataInterfaceEditable
          v-if="error"
          title="Erro ao carregar solicitações"
          subtitle="Ops! Algo deu errado. Tente recarregar a página ou entre em contato com o suporte."
        />
        <div
          v-if="!loading && !error && filteredSolicitations.length === 0"
          class="d-flex align-center justify-center"
          style="height: 200px; width: 100%; color: gray;"
        >
          <NoDataInterfaceEditable
            title="Nenhuma solicitação encontrada"
            subtitle="Tente ajustar os filtros ou criar uma nova solicitação."
          />
        </div>
        <div
          v-if="!loading && !error && filteredSolicitations.length > 0"
          class="d-flex flex-column"
          style="gap: 16px; width: 100%;"
        >
          <TransportSolicCard
            v-for="solicitation in filteredSolicitations"
            :key="solicitation.id"
            :solicitation="solicitation"
            :users-list="usersList"
            :vehicles-list="vehiclesList"
            :drivers-list="driversList"
            :solic-type="activeTab.key"
            @solic-clicked="e => handleSolicitationClick(e)"
          />
        </div>
      </section>
    </article>
    <v-dialog
      v-model="isTransportAdmSolicModalVisible"
      width="1270px"
      persistent
    >
      <TransportAdmSolicModal
        v-if="actualSelectedSolicitation"
        :key="actualSelectedSolicitation.id"
        :solic-data="actualSelectedSolicitation"
        :users-list="usersList"
        :vehicles-list="vehiclesList"
        :drivers-list="driversList"
        @updateTable="filterSolicitations"
        @close="handleCloseModal"
        @open-parent-solicitation="handleOpenParentSolicitation"
      />
    </v-dialog>
    <v-dialog
      v-model="showRegisterNewSolicitationModal"
      max-width="845px"
      persistent
    >
      <RegisterNewSolicitationModal
        :is-admin-mode="true"
        :is-manual="setIsManualValue"
        :users-list="usersList"
        :companies-list="companiesList"
        :favorite-list="favoriteList"
        :uf-list="ufList"
        @close="showRegisterNewSolicitationModal = false"
        @updateTable="filterSolicitations"
        @update-favorite-list="handleGetFavoriteAddresses"
      />
    </v-dialog>
    <v-dialog
      v-model="showModalFilter"
      max-width="530px"
      persistent
    >
      <FilterAdmSolicitationsModal
        :users-list="usersList"
        :companies-list="companiesList"
        :drivers-list="driversList"
        :favorite-list="favoriteList"
        :uf-list="ufList"
        @close="showModalFilter = false"
        @updateTable="params => filterSolicitationsWithoutStatus(params)"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { getVuetify } from '@/@core/utils'
import NoDataInterfaceEditable from '@/components/charts/NoDataInterfaceEditable.vue'
import axiosIns from '@/plugins/axios'
import {
  mdiAlertOctagramOutline,
  mdiCancel, mdiCheckboxMarkedCircleOutline,
  mdiClockTimeEightOutline,
  mdiClose, mdiEyeOutline, mdiFilterVariant, mdiFormatListChecks, mdiMagnify, mdiPlaylistPlus,
  mdiTimerSand,
} from '@mdi/js'
import axios from 'axios'
import RegisterNewSolicitationModal from '../../Solicitations/Transport/Solicitations/modals/RegisterNewSolicitationModal.vue'
import FilterAdmSolicitationsModal from './components/FilterAdmSolicitationsModal.vue'
import TransportAdmSolicModal from './components/TransportAdmSolicModal.vue'
import TransportSolicCard from './components/TransportSolicCard.vue'
import TransportSolicCardSkeleton from './components/TransportSolicCardSkeleton.vue'

export default {
  name: 'Home',
  components: {
    TransportSolicCard,
    TransportAdmSolicModal,
    TransportSolicCardSkeleton,
    NoDataInterfaceEditable,
    RegisterNewSolicitationModal,
    FilterAdmSolicitationsModal,
  },
  data() {
    return {
      setIsManualValue: true,
      activeTabIndex: 0,
      loading: false,
      error: null,
      isTransportAdmSolicModalVisible: false,
      showRegisterNewSolicitationModal: false,
      solicitations: [],
      filteredSolicitations: [],
      usersList: [],
      favoriteList: [],
      ufList: [],
      companiesList: [],
      actualSelectedSolicitation: null,
      searchInput: '',
      showModalFilter: false,
      isFiltered: false,
      filterBody: {
        created_by: '',
        status: 'new_solicitations',
        category: '',
        type: '',
        code: '',
        departure_date_time: '',
        return_date_time: '',
        date_from: '',
        date_to: '',
      },
      filterBodyWithoutStatus: {
        created_by: '',
        category: '',
        driver_id: '',
        checklist_status: '',
      },
      vehiclesList: [],
      driversList: [],
      icons: {
        mdiMagnify,
        mdiFilterVariant,
        mdiPlaylistPlus,
        mdiEyeOutline,
        mdiClose,
        mdiCancel,
      },
      tabs: [
        {
          title: 'Novas Solicitações',
          key: 'new_solicitations',
          icon: mdiAlertOctagramOutline,
          badgeBackgroundColor: '#E7E3FC1A',
          badgeTextColor: '#E7E3FC',
          solicitation_quantity: 0,
        },
        {
          title: 'Em Checklist',
          key: 'in_checklist',
          icon: mdiFormatListChecks,
          badgeBackgroundColor: '#FFB4001A',
          badgeTextColor: '#FFB400',
          solicitation_quantity: 0,
        },
        {
          title: 'Aguardando iniciar',
          key: 'awaiting_start',
          icon: mdiClockTimeEightOutline,
          badgeBackgroundColor: '#9A62FD1A',
          badgeTextColor: '#9A62FD',
          solicitation_quantity: 0,
        },
        {
          title: 'Em trânsito',
          key: 'in_trip',
          icon: mdiTimerSand,
          badgeBackgroundColor: '#16B1FF1A',
          badgeTextColor: '#16B1FF',
          solicitation_quantity: 0,
        },
        {
          title: 'Finalizadas',
          key: 'done',
          icon: mdiCheckboxMarkedCircleOutline,
          badgeBackgroundColor: '#56CA001A',
          badgeTextColor: '#56CA00',
          solicitation_quantity: 0,
        },
        {
          title: 'Canceladas',
          key: 'cancelled',
          icon: mdiCancel,
          badgeBackgroundColor: '#FF4C511A',
          badgeTextColor: '#FF4C51',
          solicitation_quantity: 0,
        },
      ],
    }
  },
  computed: {
    filterButtonColor() {
      if (!this.isDark) {
        return this.isFiltered ? 'success' : 'black'
      }

      return this.isFiltered ? 'success' : 'white'
    },
    isDark() {
      const $vuetify = getVuetify()

      return $vuetify.theme.dark
    },
    activeTab() {
      return this.tabs[this.activeTabIndex]
    },
    getTabClasses() {
      return index => ({
        isActive: this.activeTabIndex === index,
        isntActive: this.activeTabIndex !== index,
      })
    },
    getIconClasses() {
      return index => ({
        isActiveText: this.activeTabIndex === index,
      })
    },
    getTextClasses() {
      return index => ({
        isActiveText: this.activeTabIndex === index,
      })
    },
  },
  async created() {
    this.activeTabIndex = 0
    Promise.all([
      this.handleGetUsersList(),
      this.handleGetVehiclesList(),
      this.handleGetDriversList(),
      this.filterSolicitations(),
      this.handleGetFavoriteAddresses(),
      this.handleGetCompanies(),
      this.handleGetUfs(),
    ])
  },
  methods: {
    async handleGetUfs() {
      try {
        const { data } = await axios.get('https://brasilapi.com.br/api/ibge/uf/v1')
        this.ufList = data
      } catch (error) {
        console.error('Error fetching UFs:', error)
      }
    },
    async handleGetFavoriteAddresses() {
      try {
        const { data } = await axiosIns.get('/api/v1/solicitations/transport_solicitation_address_user/get_by_user_id')
        this.favoriteList = data.data
      } catch (error) {
        console.error('Erro ao buscar endereços favoritos:', error)
      }
    },
    async handleGetCompanies() {
      try {
        const { data } = await axiosIns.get('/api/v1/records/company/all')
        this.companiesList = data.data
      } catch (error) {
        console.error('Erro ao buscar concessionárias:', error)
      }
    },
    async handleGetUsersList() {
      try {
        const { data } = await axiosIns.get('/api/v1/records/user/index')

        this.usersList = (data.data || []).map(user => ({
          ...user,
          id: user.user_id || user.id,
        }))
      } catch (error) {
        console.error('Erro ao buscar lista de usuários:', error)
        this.usersList = []
      }
    },
    async handleGetVehiclesList() {
      try {
        const { data } = await axiosIns.get('/api/v1/transport/vehicles/all_vehicles')
        this.vehiclesList = data.data || []
      } catch (error) {
        console.error('Erro ao buscar lista de veículos:', error)
        this.vehiclesList = []
      }
    },
    async handleGetDriversList() {
      try {
        const { data } = await axiosIns.get('/api/v1/records/user/get_available_drivers')

        this.driversList = (data.data || []).map(driver => ({
          ...driver,
          id: driver.user_id || driver.id,
        }))
      } catch (error) {
        this.$swal({
          icon: 'warning',
          title: 'Sem permissão de acesso!',
          text: error?.response?.data?.message || 'Sem acesso.',
          showConfirmButton: false,
        })
        this.driversList = []
      }
    },
    async setActiveTab(index) {
      if (index >= 0 && index < this.tabs.length) {
        this.activeTabIndex = index

        this.filterBody.status = this.activeTab.key
        await this.filterSolicitations()
      }
    },

    handleSolicitationClick(solicitation) {
      this.actualSelectedSolicitation = solicitation
      this.isTransportAdmSolicModalVisible = true
    },

    handleCloseModal() {
      this.isTransportAdmSolicModalVisible = false
      this.actualSelectedSolicitation = null
    },

    handleOpenParentSolicitation(parentSolicitationId) {
      // Busca a solicitação pai na lista de solicitações já carregadas
      const parentSolicitation = this.solicitations.find(s => s.id === parentSolicitationId)

      if (parentSolicitation) {
        // Atualiza a solicitação selecionada para a solicitação pai
        this.actualSelectedSolicitation = parentSolicitation
      } else {
        this.$swal({
          title: 'Erro!',
          text: 'Erro ao tentar abrir a solicitação pai.',
          icon: 'error',
          showConfirmButton: false,
          timer: 3000,
        })
      }
    },

    async filterSolicitations() {
      try {
        this.loading = true
        this.error = null

        const { data } = await axiosIns.post('/api/v1/solicitations/transport_solicitation_trip/filter', this.filterBody)
        const solicitationsData = data.data || []
        const statusCount = data.status_count || {}

        this.solicitations = solicitationsData
        this.filteredSolicitations = solicitationsData

        this.tabs.forEach((tab, index) => {
          this.tabs[index].solicitation_quantity = statusCount[tab.key] || 0
        })
      } catch (error) {
        console.error('Erro ao filtrar solicitações:', error)
        this.error = 'Ocorreu um erro ao carregar solicitações'
        this.solicitations = []
        this.filteredSolicitations = []
      } finally {
        this.loading = false
      }
    },

    async filterSolicitationsWithoutStatus(bodyParams = {}) {
      try {
        this.loading = true
        this.error = null

        const { data } = await axiosIns.post('/api/v1/solicitations/transport_solicitation_trip/filter', bodyParams)
        const solicitationsData = data.data || []
        const statusCount = data.status_count || {}

        this.solicitations = solicitationsData
        this.filteredSolicitations = solicitationsData

        this.tabs.forEach((tab, index) => {
          this.tabs[index].solicitation_quantity = statusCount[tab.key] || 0
        })

        this.isFiltered = true
      } catch (error) {
        console.error('Erro ao filtrar solicitações:', error)
        this.error = 'Ocorreu um erro ao carregar solicitações'
        this.solicitations = []
        this.filteredSolicitations = []
        this.isFiltered = true
      } finally {
        this.loading = false
        this.showModalFilter = false
      }
    },

    normalize(value) {
      return (value || '').toString().toLowerCase()
    },

    handleFilterData() {
      const searchTerm = this.normalize(this.searchInput)

      this.isFiltered = !!searchTerm

      this.filteredSolicitations = this.solicitations.filter(solicitation => (
        this.normalize(solicitation.code).includes(searchTerm)
      || this.normalize(solicitation.created_by.name).includes(searchTerm)
      || this.normalize(solicitation.created_by.company.city).includes(searchTerm)
      || this.normalize(solicitation.city).includes(searchTerm)
      || this.normalize(solicitation.address?.city).includes(searchTerm)
      ))
    },

    filterReset() {
      this.searchInput = ''
      this.isFiltered = false
      this.filterBody = {
        created_by: '',
        status: this.activeTab.key,
        category: '',
        type: '',
        code: '',
        departure_date_time: '',
        return_date_time: '',
        date_from: '',
        date_to: '',
      }
      this.filterSolicitations()
    },
  },
}
</script>

<style scoped>
.container-header{
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 30px 30px;
}
.container-header-actions{
  display: flex;
  gap: 16px;
}

article {
  display: flex;
  width: 100%;
}

article section:nth-child(1) {
  width: 20.95%;
}

article section:nth-child(2) {
  width: 76.86%;
  padding-right: 2.19%;
}

.isActive {
  border-left: 4px solid #FF821A;
}
.isntActive {
  border-left: 4px solid transparent;
  transition: border-left 0.2s ease;
}
.isntActive:hover {
  border-left: 4px solid #FF821A40;
}
.isActiveText {
  color: #FF821A;
  font-weight: 700;
}
.isntActive:hover .v-icon,
.isntActive:hover span {
  color: #FF821A80;
}

.scroll-area {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  padding-right: 8px;
}

.scroll-area::-webkit-scrollbar {
  width: 6px;
}

.scroll-area::-webkit-scrollbar-track {
  background: #2D2640;
  border-radius: 3px;
}

.scroll-area::-webkit-scrollbar-thumb {
  background: #534D74;
  border-radius: 3px;
}

.scroll-area::-webkit-scrollbar-thumb:hover {
  background: #7B7792;
}

@media (max-width: 1024px) and (min-width: 769px) {
  article section:nth-child(1) {
    width: 25%;
  }

  article section:nth-child(2) {
    width: 75%;
  }
}

@media (max-width: 768px) {
  .container-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }

  .container-header-actions {
    justify-content: center;
    flex-wrap: wrap;
  }

  article {
    flex-direction: column;
  }

  article section:nth-child(1) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
  }

  article section:nth-child(1) > div {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  article section:nth-child(2) {
    width: 100%;
    padding-right: 0;
  }

  .scroll-area {
    max-height: calc(100vh - 300px);
  }
}
</style>
